import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=2067dde8&"
import script from "./BaseSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=2067dde8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2067dde8')) {
      api.createRecord('2067dde8', component.options)
    } else {
      api.reload('2067dde8', component.options)
    }
    module.hot.accept("./BaseSwitch.vue?vue&type=template&id=2067dde8&", function () {
      api.rerender('2067dde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/BaseSwitch.vue"
export default component.exports